<template>
  <div class="background">
    <div id="bot">
      <svg viewBox="0 0 628.2 18.53">
        <g v-for="tick in ticks" :key="tick.string">
          <text :x="tick.x" y="13" font-size="13">{{ tick.string }}</text>
        </g>
      </svg>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TimeAxisSlim',
  props: {
    startTime: {
      type: Date,
      required: false
    },
    endTime: {
      type: Date,
      required: false
    }
  },
  computed: {
    ticks() {
      return this.calcTicks()
    }
  },
  methods: {
    calcTicks() {
      let EndTime = this.endTime
      let StartTime = this.startTime
      if (!EndTime || !StartTime) {
        return []
      }
      let Width = 628.2
      let pastIncrement // milliseconds

      // Tick spacing
      let hoursBetween = (EndTime - StartTime) / (1000 * 3600)
      if (hoursBetween < 0.25) {
        pastIncrement = 2 * 60 * 1000
      } else if (hoursBetween < 0.5) {
        pastIncrement = 5 * 60 * 1000
      } else if (hoursBetween < 1) {
        pastIncrement = 15 * 60 * 1000
      } else if (hoursBetween < 2) {
        pastIncrement = 30 * 60 * 1000
      } else {
        pastIncrement = 60 * 60 * 1000
      }

      // Time Axis Ticks
      let pastAxisTimeSpan = EndTime - StartTime
      let startTimeTrimmed = new Date(
        StartTime.getTime() + (-StartTime.getTime() % pastIncrement)
      )
      let timesBetweenList = []
      for (let i = 0; i <= Math.round(pastAxisTimeSpan / pastIncrement); i++) {
        timesBetweenList.push(
          new Date(startTimeTrimmed.getTime() + i * pastIncrement)
        )
      }

      // Scale Axis
      let pastAxisLength = Width

      // Past Axis
      let ticks = []
      for (const time of timesBetweenList) {
        let labelDatetime = this.makeTimeString(time)
        let x = ((time - StartTime) / pastAxisTimeSpan) * pastAxisLength
        ticks.push({
          string: labelDatetime,
          x: x
        })
      }
      return ticks
    },
    makeTimeString(date) {
      let hour = date.getHours()
      let minute = date.getMinutes()
      return this.makeDoubleDigit(hour) + ':' + this.makeDoubleDigit(minute)
    },
    makeDoubleDigit(x) {
      return x < 10 ? '0' + x : x
    }
  }
}
</script>

<style scoped>
.background {
  background-color: #d8d8d8;
  border-style: solid;
  border-width: thin;
  border-color: #979797;
  display: grid;
  grid-template-rows: 100%;
}
#bot {
  grid-row: 1;
  grid-column: 1;
  font-weight: bold;
}
text {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
}
svg {
  display: block;
}
</style>
